<template>
  <div>
    <Breadtabsheader />
    <div class="h-content">
      <!-- 搜素条件 -->
       <div class="h-piece">
        <div class="h-formBox">
          <el-form
            :inline="true"
            :model="q"
            class="demo-form-inline h-formBorder"
          >
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="客户">
                <el-input
                  v-model="q.userName"
                  placeholder="请输入客户名称"
                  clearable="clearable"
                ></el-input>
              </el-form-item>
              <el-form-item label="地市" class="h-elformWrap-2">
              <el-select v-model="cityMultiple" @change="handleItemChange1" :multiple="true" placeholder="地市" >
                <el-option
                    v-for="item in cityList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.name">
                </el-option>
              </el-select>
              </el-form-item>
            </div>
          </el-form>
          <div class="l-screenBox">
            <div class="l-retrieval">
              <el-button
                class="h-btn h-formBtn"
                @click="handleFilter"
              >检索</el-button>
              <el-button
                class="h-btn h-formBtn h-bgwhite"
                @click="rest"
              >重置</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 结果展示 -->
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
          ref="multipleTable"
          :data="tableData"
          :border="true"
          max-height="560"
          style="width: 100%"
        >
          <el-table-column
            label="序号"
            type="index"
            width="50px"
          >
          </el-table-column>
         <el-table-column
            prop="periodCode"
            label="日期"
            min-width="100"
            show-overflow-tooltip
         ></el-table-column>
        <el-table-column
            prop="version"
            label="累计版本"
            min-width="100"
            show-overflow-tooltip
        ></el-table-column>
          <el-table-column
            prop="regionName"
            label="省份"
            min-width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="city"
            label="城市"
            min-width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="agentName"
            label="经销商"
            min-width="130"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="userName"
            label="用户"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="channelName"
            label="渠道"
            min-width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="yjmb"
            label="签约目标"
            min-width="100"
          ></el-table-column>
          <!-- <el-table-column
            prop="telephone"
            label="电话"
            min-width="100"
          ></el-table-column> -->
          <el-table-column
            prop="email"
            label="实际"
            min-width="100"
          >
            <el-table-column
              label="超低温/低温"
              min-width="100"
            >
              <el-table-column
                prop="超低温销量"
                label="销量"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="超低温收入"
                label="收入"
                min-width="80"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="药品箱"
              min-width="100"
            >
              <el-table-column
                prop="药品箱销量"
                label="销量"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="药品箱收入"
                label="收入"
                min-width="80"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="安全柜"
              min-width="100"
            >
              <el-table-column
                prop="安全柜销量"
                label="销量"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="安全柜收入"
                label="收入"
                min-width="80"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="培养箱"
              min-width="100"
            >
              <el-table-column
                prop="培养箱销量"
                label="销量"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="培养箱收入"
                label="收入"
                min-width="80"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="离心机"
              min-width="100"
            >
              <el-table-column
                prop="离心机销量"
                label="销量"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="离心机收入"
                label="收入"
                min-width="80"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="血液"
              min-width="100"
            >
              <el-table-column
                prop="血液销量"
                label="销量"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="血液收入"
                label="收入"
                min-width="80"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="疫苗"
              min-width="100"
            >
              <el-table-column
                prop="疫苗销量"
                label="销量"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="疫苗收入"
                label="收入"
                min-width="80"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="其他"
              min-width="100"
            >
              <el-table-column
                prop="其他销量"
                label="销量"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="其他收入"
                label="收入"
                min-width="80"
              >
              </el-table-column>
            </el-table-column>
            <el-table-column
              label="小计"
              min-width="100"
            >
              <el-table-column
                prop="小计销量"
                label="销量"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="小计收入"
                label="收入"
                min-width="80"
              >
              </el-table-column>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="预算完成率"
            min-width="100"
          >
            <el-table-column
              prop="finishSchool"
              min-width="80"
            >
              <el-table-column
                prop="预算完成率"
                label="收入"
                min-width="100"
              >
                <template slot-scope="scope">
                  <span>{{scope.row.预算完成率}}%</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <div class="h-tableB h-mrt30">
        <!--  -->
        <div class="h-tableBL">

        </div>
        <!-- 分页 -->
        <div class="h-pagination2">
          <pagination
            :page="q"
            @query="selectPageAll"
          />
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import updownfile from '@/utils/updownfile'
import moment from "moment";
import ss from '@/api/SystemService'
export default {
  data () {
    return {
      //省份名称
      seriesName:null,
      cityPlus:null,
      cityMultiple:'',
      q: {
        agentCode: '',
        city: '',
        regionName:null,
        userName:null,
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      tableData: [],
      cityList:[],
    }
  },
  methods: {
    //明细导出
    exportExcel () {
      updownfile.down("/api/swyl/v1/guanhuai/bscContactPerson/newDownloadExcel", this.q, "post", 'data');
    },

    selectPageAll () {
      if (null == this.q.city || '' == this.q.city){
        this.q.city = this.cityPlus;
        this.q.regionName = ''
      }else {
        if (this.q.city.indexOf("全部") != -1){
          this.q.regionName = this.seriesName
        }else {
          this.q.regionName = ''
        }
      }
      ss.noticeBoard.selectAgentDataPage(this.q).then(res => {
        this.tableData = res.records
        this.q.total = res.total;

      })
    },
    //检索
    handleFilter(){
      this.selectPageAll();
    },
    //重置
    rest(){
      this.q.city = this.cityPlus;
      this.q.userName = null;
      this.cityMultiple = '';
    },
    //选择地市
    handleItemChange1(val){
      console.log(val)
      this.q.city = val.join(',')
    },
  },

  created () {
    this.q.agentCode = this.$route.query.agentCode || ''
    this.q.city = this.$route.query.cityName || ''

    this.cityPlus = this.$route.query.cityName || '';
    this.seriesName = this.$route.query.seriesName || '';
    if (this.seriesName){
      //根据省份获取下一级城市信息
      let requestBody = {
            name: this.seriesName,
            level: 2,
          };
      ss.Dictservice.selNextBscAddressByName(requestBody).then(rd => {
        this.cityList = rd;
        let a = {name:"全部",value:"98u8wds"};
        this.cityList.unshift(a);

      })
    }
  },
  mounted () {
    this.selectPageAll();
  },

}
</script>
<style scoped>
/* 修改弹出窗布局 (字段 展示 问题) */
::v-deep .h-formbLine .el-form-item__label {
  width: 90px;
}
::v-deep .h-formbLine .el-form-item__content {
  width: 150px;
}
::v-deep .h-elformWrap-1 .el-form-item__content {
  width: 78%;
}

/*.projectCon p{*/
/*  justify-content: space-between;*/
/*  align-items:center;*/
/*  font-size: 14px;*/
/*  border-bottom:#1b78e6 1px dashed;*/
/*  padding: 5px 0;*/
/*  margin: 0 auto 10px auto;*/
/*  color: #1b78e6;*/
/*}*/
</style>
